import getMeta from '@atlassian/jira-get-meta';

export const isAgilityBoard =
	// this meta actually checks if backlog is using issueLists

	getMeta('ghx-simply-filters-enabled') === 'true';
